/**
 * LangCode：パラメータ値のセットに用いる
 */
export type LangCode = (typeof LangCode)[keyof typeof LangCode];
export const LangCode = {
  /** 言語情報="ja"(日本語)の場合 */
  JA: 'ja',
  /** 上記以外の場合 */
  EN: 'en',
} as const;
